import React from 'react';
import { Grid } from '@material-ui/core';
import { AssuranceIcon } from 'images/index';
import { IntlShape, injectIntl } from 'react-intl';
import messages from 'components/NotificationsBloc/messages';
import {
  InlineCaption,
  EndAlignGrid,
  ArrowIcon,
  FilCaption,
  OvalIcon,
  OvalGrid,
  IgnoreCaption,
  NotificationsWrapper,
} from 'components/NotificationsBloc/styles';
import { translate } from 'helpers/intl';
import { getTextBetweenQuotation } from 'utils/string';
export interface NotificationsBlocTypeProps {
  intl: IntlShape;
  ignoreNotify: Function;
  message: string;
  clickEvent: any;
}

const NotificationsBloc = ({
  ignoreNotify,
  message,
  clickEvent,
  ...props
}: NotificationsBlocTypeProps) => {
  return (
    <React.Fragment>
      {message && (
        <NotificationsWrapper>
          <Grid container>
            <Grid xs={6} item>
              <FilCaption color="white" weight="400">
                {translate({ ...messages.newsFeed }, props)}
              </FilCaption>
            </Grid>
            <Grid xs={6} item>
              <IgnoreCaption
                color="white"
                weight="400"
                data-testid="ignore"
                onClick={ignoreNotify}
              >
                {translate({ ...messages.ignore }, props)}
              </IgnoreCaption>
            </Grid>
            <OvalGrid xs item>
              <OvalIcon
                src={AssuranceIcon['OvalRed']}
                alt="notification-icon"
              />
            </OvalGrid>

            <Grid xs={10} item>
              <InlineCaption
                onClick={clickEvent}
                color="white"
                weight="400"
                data-testid="notification"
                isLeft
              >
                {getTextBetweenQuotation(message)}
              </InlineCaption>
            </Grid>
            <EndAlignGrid xs item>
              <ArrowIcon
                data-testid="arrow-icon"
                onClick={clickEvent}
                src={AssuranceIcon['arrow']}
                alt=""
              />
            </EndAlignGrid>
          </Grid>
        </NotificationsWrapper>
      )}
    </React.Fragment>
  );
};

export default injectIntl(NotificationsBloc);
